import { isMembersFestival } from '@/utils/membersFestival';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import EcoIconClose from 'eco-design-micro/icons/eco-icon-close';
import { signupCookie } from 'eco-design-reliance/cookies/signupCookie';
import getLocal from 'eco-design-reliance/getLocal';
import gtm from 'eco-design-reliance/gtm';
import EcoLink from 'eco-design/base/eco-link';
import { useEffect, useState } from 'react';
import './index.scss';

const useLang = () => {
    const { locale = 'us' } = getLocal();
    const langText: Record<string, { [key: string]: string }> = {
        au: {
            desc: 'Get 500 EcoCredits, Worth $25',
            desc_1: 'Get 800 EcoCredits,Worth $40',
            button: 'Join Now',
            button1: 'Password-free Login/Register',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        us: {
            desc: 'Get 500 EcoCredits, Worth $25',
            desc_1: 'Get 700 EcoCredits, Worth $35',
            button: 'Join Now',
            button1: 'Password-free Login/Register',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        ca: {
            desc: 'Get 500 EcoCredits, Worth $25',
            desc_1: 'Get 800 EcoCredits, Worth $40',
            button: 'Join Now',
            button1: 'Password-free Login/Register',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        cis: {
            desc: 'Get 500 EcoCredits, Worth $25',
            desc_1: 'Get 500 EcoCredits, Worth $25',
            button: 'Join Now',
            button1: 'Password-free Login/Register',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        cn: {
            desc: 'Get 500 EcoCredits, Worth $25',
            desc_1: 'Get 500 EcoCredits, Worth $25',
            button: 'Join Now',
            button1: 'Password-free Login/Register',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        de: {
            desc: 'Sie erhalten 500 EcoCredits im Wert von 25 €',
            desc_1: 'Sie erhalten 800 EcoCredits im Wert von 40 €',
            button: 'Jetzt registrieren',
            button1: 'Anmelden/Registrieren ohne Passwort',
            register_tip: 'Bereits Mitglied? ',
            login: 'Einloggen',
        },
        en: {
            desc: 'Get 500 EcoCredits, Worth $25',
            desc_1: 'Get 500 EcoCredits, Worth $25',
            button: 'Join Now',
            button1: 'Password-free Login/Registration',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        es: {
            desc: 'Obtén 500 EcoCredits, con un valor de 25 €',
            desc_1: 'Obtén 800 EcoCredits, con un valor de 40 €',
            button: 'Únete ahora',
            button1: 'Inicio de sesión/registro sin contraseña',
            register_tip: '¿Ya tienes una cuenta? ',
            login: 'Inicia sesión',
        },
        eu: {
            desc: 'Get 500 EcoCredits, Worth €25',
            desc_1: 'Get 800 EcoCredits,Worth €40',
            button: 'Join Now',
            button1: 'Password-free Login/Register',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        fr: {
            desc: "Obtenez 500 EcoCredits d'une valeur de 25 €",
            desc_1: "Obtenez 800 EcoCredits d'une valeur de 40 €",
            button: 'Rejoignez-nous maintenant',
            button1: 'Connexion sans mot de passe/Inscription',
            register_tip: 'Vous avez déjà un compte? ',
            login: 'Se connecter',
        },
        hk: {
            desc: 'Get 500 EcoCredits, Worth €25',
            desc_1: 'Get 500 EcoCredits, Worth €25',
            button: 'Join Now',
            button1: 'Password-free Login/Register',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        it: {
            desc: 'Ricevi 500 EcoCredits del valore di 25 €',
            desc_1: 'Ricevi 800 EcoCredits del valore di 40 €',
            button: 'Unisciti ora',
            button1: 'Accesso/registrazione senza password',
            register_tip: 'Hai già un account? ',
            login: 'Accedi',
        },
        jp: {
            desc: '500 エコポイント をゲット',
            desc_1: '800エコポイントをゲット',
            button: '今すぐ登録する',
            button1: 'パスワードなしでログイン／新規登録',
            register_tip: 'すでにアカウントをお持ちですか？ ',
            login: 'ログイン',
        },
        kr: {
            desc: '500 에코포인트(₩35,000 상당)를 받으세요',
            desc_1: '800 EcoCredits(56,000₩ 상당)를 받으세요',
            button: '지금 가입하기',
            button1: '비밀번호 없이 로그인/회원가입',
            register_tip: '기존 사용자이신가요? ',
            login: '로그인',
        },
        sa: {
            desc: 'Get 500 EcoCredits, Worth €25',
            desc_1: 'Get 500 EcoCredits, Worth €25',
            button: 'Join Now',
            button1: 'تسجيل الدخول/التسجيل دون كلمة مرور',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        tw: {
            desc: 'Get 500 EcoCredits, Worth €25',
            desc_1: 'Get 500 EcoCredits, Worth €25',
            button: 'Join Now',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        uk: {
            desc: 'Get 500 EcoCredits, Worth £25',
            desc_1: 'Get 800 EcoCredits,Worth £40',
            button: 'Join Now',
            button1: 'Password-free Login/Register',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        za: {
            desc: 'Get 500 EcoCredits, Worth R500',
            desc_1: 'Get 800 EcoCredits,Worth R800',
            button: 'Join Now',
            button1: 'Password-free Login/Register',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
        br: {
            desc: 'Ganhe 500 EcoCredits no valor de R$ 100',
            desc_1: 'Ganhe 800 EcoCredits no valor de R$ 40',
            button: 'Inscreva-se agora',
            button1: 'Registro/login sem senha',
            register_tip: 'Usuário existente? ',
            login: 'Faça login',
        },
        mx: {
            desc: 'Obtenga 500 EcoCredits con un valor de MXN 500',
            desc_1: 'Obtenga 800 EcoCredits con un valor de MXN 40',
            button: 'Únase ahora',
            button1: 'Inicio de sesión/Registro sin contraseña',
            register_tip: '¿Ya tienes una cuenta? ',
            login: 'Inicia sesión',
        },
        ph: {
            desc: 'Get 500 EcoCredits, worth  ₱1,500',
            desc_1: 'Get 500 EcoCredits, worth  ₱1,500',
            button: 'Join Now',
            button1: 'Password-free Login/Register',
            register_tip: 'Existing user? ',
            login: 'Log in',
        },
    };
    const copies = langText[locale] || langText['us'];

    return {
        t: (text: string) => copies[text] || text,
    };
};
// 没有登录
export default function HeaderUserTipsContent({ closeCallback }: { closeCallback?: any }) {
    const { locale = 'us' } = getLocal();
    const { t } = useLang();
    const [registerUrl, setRegisterUrl] = useState('');
    // const [registerUrl1, setRegisterUrl1] = useState('');
    const [loginUrl, setLoginUrl] = useState('');
    // const [showLoginModal, setShowLoginModal] = useState(false);
    // const [isClient, setIsClient] = useState(false);

    const mfStatus = locale === 'us' ? isMembersFestival(locale) : 1;

    useEffect(() => {
        setRegisterUrl(`${window.location.origin}/${locale}/register?redirect=${encodeURIComponent(window.location.href)}`);
        // setRegisterUrl1(`${window.location.origin}/${locale}/register/passwordless?redirect=${encodeURIComponent(window.location.href)}`);
        setLoginUrl(`${window.location.origin}/${locale}/login?redirect=${encodeURIComponent(window.location.href)}`);
    }, []);
    const textButton = t('button');
    const textButton1 = t('button1');
    const textTips1 = t('register_tip');
    const textLogin = t('login');
    const closeHandle = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'floating_close',
            button_name: 'Close',
            type: 'Authentication',
        });
        if (closeCallback) {
            closeCallback();
        }
    };

    // useEffect(() => {
    //     if (typeof window !== 'undefined') {
    //         setIsClient(true);
    //     }
    // }, []);

    return (
        <div className="HeaderV2-UserTipsWin-content">
            <div className="HeaderV2-UserTipsWin-line1">
                <TipsIconA />
                {mfStatus === 0 ? t('desc_1') : t('desc')}
            </div>
            <EcoLink
                className="HeaderV2-UserTipsWin-line2"
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'authentication_button',
                    type: 'Modal',
                    button_name: textButton1,
                    url: 'none',
                }}
                // href={registerUrl1}
                onClick={(event) => {
                    event.stopPropagation();
                    signupCookie?.({
                        entry_name: 'top floating_Password-free Register',
                        page_url: window.location.href,
                    });
                    closeCallback && closeCallback();
                    EcoDesignEventsBus.emit('GlobalLoginRegisterA-open', true);
                }}
            >
                {textButton1}
            </EcoLink>
            <EcoLink
                className="HeaderV2-UserTipsWin-line4"
                href={registerUrl}
                onClick={() => signupCookie?.({ entry_name: 'top floating' })}
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'signup_start',
                    entry_type: 'fixed entry',
                    entry_name: 'top floating',
                    entry_position: 'none',
                    source_channel: 'Website',
                }}
            >
                {textButton}
            </EcoLink>
            <div className="HeaderV2-UserTipsWin-line3">
                {textTips1}
                <EcoLink
                    className="HeaderV2-UserTipsWin-line3-link"
                    href={loginUrl}
                    onClick={() => signupCookie?.({ entry_name: 'top floating' })}
                    dataLayer={{
                        event: 'uaEvent',
                        event_name: 'signup_start',
                        entry_type: 'fixed entry',
                        entry_name: 'top floating',
                        entry_position: 'none',
                        source_channel: 'Website',
                    }}
                >
                    {textLogin}
                </EcoLink>
            </div>
            <EcoIconClose className="HeaderV2-UserTipsWin-close" onClick={closeHandle} />
        </div>
    );
}

const TipsIconA = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.66666 8.00016L5.99999 11.3335L13.3333 4.3335" stroke="#30BF00" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
        </svg>
    );
};
